import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import './FAQ.scss';

export default function FAQ() {
  const { t } = useI18n();
  const items = t('videoGeneration.sora.faq.items');
  return (
    <section className="sora2-faq">
      <div className="sora2-faq__inner">
        <h2>{t('videoGeneration.sora.faq.title')}</h2>
        <p className="sora2-faq__sub">{t('videoGeneration.sora.faq.sub')}</p>
        <div className="sora2-faq__list">
          {items.map((item) => (
            <div key={item.num} className="sora2-faq__item">
              <div className="sora2-faq__num">{item.num}</div>
              <div className="sora2-faq__content">
                <h3>{item.q}</h3>
                <p>{item.a}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="sora2-faq__cta">
          <button
            type="button"
            className="sora2-faq__link"
          >
            {t('videoGeneration.sora.faq.cta')}
            <span>{t('videoGeneration.sora.faq.contact')}</span>
          </button>
        </div>
      </div>
    </section>
  );
}
